<template>
  <div :class="{ 'ful-section': !bare }" v-if="consultInfo">
    <!-- bare 模式：可折叠 -->
    <div v-if="bare">
      <button @click="collapsed = !collapsed" class="ful-collapse-trigger">
        <span class="ful-inner-section-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        </span>
        <div class="ful-collapse-title">
          <h2 class="ful-inner-section-title">{{ chaoweiMode ? '基本信息' : '患者基本信息' }}</h2>
        </div>
        <span class="ful-collapse-hint">{{ collapsed ? '点击展开' : '点击收起' }}</span>
        <svg class="ful-chevron" :class="{ 'is-open': !collapsed }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>
    <div v-else class="ful-section-heading">
      <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
      <h2 class="ful-section-title">基本信息</h2>
    </div>

    <!-- 折叠内容：信息网格 -->
    <div :class="['ful-collapse-body', { 'is-collapsed': bare && collapsed }]">
      <div class="info-grid">
        <div class="info-item" v-if="!isEmptyValue(consultInfo.name)">
          <span class="info-label">姓名：</span>
          <span class="info-value">{{ consultInfo.name }}</span>
        </div>
        <div class="info-item" v-if="!isEmptyValue(consultInfo.sex)">
          <span class="info-label">性别：</span>
          <span class="info-value">{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
        </div>
        <div class="info-item" v-if="!isEmptyValue(consultInfo.phoneNo)">
          <span class="info-label">电话：</span>
          <span class="info-value">{{ consultInfo.phoneNo }}</span>
        </div>
        <div class="info-item" v-if="!isEmptyValue(consultInfo.birthday) || !isEmptyValue(consultInfo.birthHour) || !isEmptyValue(consultInfo.birthMinute)">
          <span class="info-label">出生日期：</span>
          <span class="info-value">{{ consultInfo.birthday }}<span v-if="shouldShowTime(consultInfo.birthHour, consultInfo.birthMinute)"> {{ formatTimeValue(consultInfo.birthHour) }}:{{ formatTimeValue(consultInfo.birthMinute) }}</span></span>
        </div>
        <div class="info-item" style="grid-column:1/-1" v-if="!isEmptyValue(consultInfo.liveArea)">
          <span class="info-label">常住地址：</span>
          <span class="info-value">{{ consultInfo.liveArea }}</span>
        </div>
        <div class="info-item" style="grid-column:1/-1" v-if="!isEmptyValue(consultInfo.birthArea)">
          <span class="info-label">出生地址：</span>
          <span class="info-value">{{ consultInfo.birthArea }}</span>
        </div>
        <div class="info-item" v-if="!isEmptyValue(consultInfo.useDate)">
          <span class="info-label">开始服药时间：</span>
          <span class="info-value">{{ consultInfo.useDate }}</span>
        </div>
        <div class="info-item" v-if="!isEmptyValue(consultInfo.useDays)">
          <span class="info-label">服药天数：</span>
          <span class="info-value">{{ consultInfo.useDays }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientInfo',
  props: {
    consultInfo: { type: Object, default: null },
    bare: { type: Boolean, default: false },
    // 超微饮片模式：折叠标题改为「处方信息」
    chaoweiMode: { type: Boolean, default: false }
  },
  data() {
    return { collapsed: true }
  },
  methods: {
    shouldShowTime(hour, minute) {
      return !(this.isEmptyValue(hour) && this.isEmptyValue(minute))
    },
    isEmptyValue(value) {
      return value === '' || value === null || value === undefined
    },
    formatTimeValue(value) {
      if (value === '-1' || value === -1 || value === '--') return '--'
      return value
    }
  }
}
</script>
